import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();

/*出货*/

export const GetERP_StockOutByPage = params => { return axios.get(`${base}/api/StockOut/GetERP_StockOutByPage`, { params: params }); };
export const GetOtherStockOutByPage = params => { return axios.get(`${base}/api/StockOut/GetOtherStockOutByPage`, { params: params }); };
export const GetThirdStockOutByPage = params => { return axios.get(`${base}/api/StockOut/GetThirdStockOutByPage`, { params: params }); };

export const ERP_StockOutDel = params => { return axios.post(`${base}/api/StockOut/ERP_StockOutDel`, params, config); }; //删除
export const ERP_InvalidStockOut = params => { return axios.get(`${base}/api/StockOut/ERP_InvalidStockOut`, { params: params }); }; //作废
export const GetERP_StockOutById = params => { return axios.get(`${base}/api/StockOut/LoadStockOutByIdForUpdate`, { params: params }); };
export const LoadThirdStockOutByIdForUpdate = params => { return axios.get(`${base}/api/StockOut/LoadThirdStockOutByIdForUpdate`, { params: params }); }; //出库单-修改-海信

//查看出库单
export const GetERP_StockOutById2 = params => { return axios.get(`${base}/api/StockOut/GetERP_StockOutById`, { params: params }); };

//添加出库单
export const ERP_StockOutAdd = params => { return axios.post(`${base}/api/StockOut/ERP_StockOutAdd`, params, config); };
//更新出库单
export const ERP_StockOutUpdate = params => { return axios.post(`${base}/api/StockOut/ERP_StockOutUpdate`, params, config); };
export const StockOutPrint = params => { return axios.get(`${base}/api/StockOut/StockOutPrint`, { params: params }); };
export const LoadDataForStockOutPrint = params => { return axios.get(`${base}/api/StockOut/LoadDataForStockOutPrint`, { params: params }); };
export const GetStockOutForStockByPage = params => { return axios.get(`${base}/api/StockOut/GetStockOutForStockByPage`, { params: params }); };


// WEBPACK FOOTER //
// ./src/api/stockOutApi.js